import { action } from 'redux/lib/api';

export const setPeriodAction = (period) => {
  action('SET_PERIOD', period);
};

export const setPeriodPerformanceAction = (period) => {
  action('SET_PERIOD_PERFORMANCE', period);
};
